<script>
  import { onMount } from "svelte";
  export let goToPreviewScreen;
  //export let goToQuestionnaire;

  export let personality;
  let canvas;
  let transform = 0.1;
  let scale = 1.0;
  let colorOffset = 0;

  $: onChange(transform, scale, colorOffset, personality);

  let player;
  onMount(async () => {
    player = new figmentPlayer.Player("canvas");
    await player.load("patterngenerator.fgmt"); //figment file hier
    await player.start();
    onChange(transform, scale, colorOffset, personality);
  });

  async function onChange(transform, scale, colorOffset, personality) {
    if (!player) return;
    changeFigmentParameter(
      "ImageSwitch",
      "index",
      personality.favoriteImageIndex + 1
    );
    if (personality.minimalism > personality.maximalism) {
      changeFigmentParameter("MinMaxSwitch", "index", 1);
    } else {
      changeFigmentParameter("MinMaxSwitch", "index", 2);
    }
    if (personality.symmetry > personality.asymmetry) {
      changeFigmentParameter("SymAsymSwitch", "index", 1);
    } else {
      changeFigmentParameter("SymAsymSwitch", "index", 2);
    }

    // Calculate the value of lightness as the difference between light and dark
    const lightness = personality.light - personality.dark;
    // Convert the lightness (range [-3 - +3]) to a color index [1 - 7]
    const colorSwitchIndex = lightness + colorOffset + 5;
    changeFigmentParameter("ColorSwitch", "index", colorSwitchIndex);

    changeFigmentParameter("Transform", "rotate", 90 + transform);
    changeFigmentParameter("Scale", "scaleX", scale);

    await player.render();
  }

  function setColorOffset(offset) {
    colorOffset = offset;
  }

  function changeFigmentParameter(nodeName, portName, value) {
    if (!player) return;
    const network = player.network;
    const node = network.nodes.find((n) => n.name === nodeName);
    if (!node) {
      console.error(`Node ${nodeName} not found.`);
      return;
    }
    network.setPortValue(node, portName, parseFloat(value));
  }

  function finishDesign() {
    const gl = player.gl;
    // Find the output node.
    const outNode = player.network.nodes.find((n) => n.type === "core.out");
    // Get the data of its framebuffer.
    const framebufferWrapper = outNode.outPorts[0].value._fbo;
    const framebuffer = framebufferWrapper.framebuffer;
    // Bind the framebuffer to read its pixels.
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
    // Create a new buffer the size of the framebuffer.
    // Each pixel has 4 bytes (R/G/B/A).
    const buffer = new Uint8ClampedArray(
      framebufferWrapper.width * framebufferWrapper.height * 4
    );
    // Read in the pixels of the framebuffer.
    gl.readPixels(
      0,
      0,
      framebufferWrapper.width,
      framebufferWrapper.height,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      buffer
    );

    console.log(buffer);
    // for (let i = 0; i < buffer.length; i++) {
    //   buffer[i] = Math.floor(Math.random() * 256);
    // }
    const designImageData = new ImageData(
      buffer,
      framebufferWrapper.width,
      framebufferWrapper.height
    );

    goToPreviewScreen(designImageData);
  }
</script>

<p>make your design here!</p>
<p>
  if you don't see your design, please be patient. It can take a few seconds
</p>
<div class="slider">
  <input type="range" min="0" max="360" step="1" bind:value={transform} />
  <span class="slider-value">{transform}</span>
</div>
<div class="slider">
  <input type="range" min="0.3" max="1.3" step="0.01" bind:value={scale} />
  <span class="slider-value">{scale}</span>
</div>
<div class="color-buttons">
  <button on:click={() => setColorOffset(-1)}
    ><img src="/icons/color-black.png" alt="Black" /></button
  >
  <button on:click={() => setColorOffset(0)}
    ><img src="/icons/color-black.png" alt="Black" /></button
  >
  <button on:click={() => setColorOffset(1)}
    ><img src="/icons/color-black.png" alt="Black" /></button
  >
</div>

<canvas bind:this={canvas} id="canvas" width="512" height="512" />
<hr />
<button on:click={finishDesign}> My design is ready</button>

<a href="/">
  <button>I want to try again</button>
</a>

<style>
  p {
    color: #020202;
    font-size: 2, 5em;
    font-weight: 100;
  }
  .slider-value {
    display: inline-block;
    width: 100px;
    overflow: hidden;
    background: #eee;
  }
  .color-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  .color-buttons button {
    border: none;
    background: none;
  }
</style>
